<template>
  <div class="col-md-10 col-md-offset-1"
        v-loading="!verification"
        element-loading-spinner="qc-spinner">
    <div ref="printFrom" class="card card-verification" :verification-status="resolvedResult">
      <div class="card-header">
        <h4 class="card-title">
          <span v-if="result && result.startsWith('RESOLVE')">
            <span v-if="$service.isEmp(v.institute)">Employment Verification:</span> 
            <span v-else>Education Verification:</span> 
          </span>
          <span>{{v.firstname}} {{v.lastname}}</span>
          <span v-if="result && !result.startsWith('RESOLVE')" class="vBadge pull-right">
            <br/><br/>
            <slot name="vBadge">
              <span class="vBadge-inner">{{formatResult(result)}}</span>
            </slot>
          </span>
        </h4>
      </div>
      <div class="card-content row form-horizontal">
        <div class="state">
            <i class="fa fa-3x" style="padding-top: 7px"></i>
        </div>

        <div v-if="v.id" class="form-group" style="font-size: 80%; color: #b0b0b0">
          <label class="col-sm-2 control-label">QCID</label>
          <div class="col-sm-10 form-control-static" style=" min-height: 0">
            {{v.id}}
          </div>
          <div v-if="result && !result.startsWith('RESOLVE') && v.customerReference">
            <label class="col-sm-2 control-label" style="padding-top: 0px !important">{{$store.getters.refLabel}}</label>
            <div class="col-sm-10 form-control-static" style="padding-top: 0px !important; min-height: 0">
              {{v.customerReference}}
            </div>
          </div>
        </div>

        <div v-if="!$service.isEmp(v.institute) && !$service.isId(v.institute) && !$service.isHSC(v.institute)">
          <div class="form-group">
            <label class="col-sm-2 control-label">Institute</label>
            <div class="col-sm-10 form-control-static">
              <div v-if="v.institute.names && v.institute.names.length > 0">
                <div v-for="name in v.institute.names">{{name.name}}</div>
              </div>
              <div v-else>{{v.institute.name}}</div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">Institute country</label>
            <div class="col-sm-10 form-control-static">
              {{v.institute.region}}
            </div>
          </div>
          <div v-if="result && !result.startsWith('RESOLVE') && v.accreditation 
            && (v.accreditation.status == 'PENDING' 
                || v.accreditation.status == 'ACCREDITED'
                || v.accreditation.status == 'NOT_ACCREDITED')" class="form-group">
            <label class="col-sm-2 control-label">Institute accreditation</label>
            <div v-if="v.accreditation.status == 'PENDING'" class="col-sm-10 form-control-static">
              <el-tooltip placement="right">
                <div slot="content">This institute accreditation check (ID: {{ v.accreditation.id }}) is handled separately from the education verification.<br/>It is still pending with our team, you will be notified when it is completed.</div>
                <div class="btn btn-fill btn-warning"><i class="fa fa-search" /> Accreditation check pending...</div>
              </el-tooltip>
            </div>
            <div v-else-if="v.accreditation.status == 'ACCREDITED'" class="col-sm-10 form-control-static">
              Accredited by {{ v.accreditation.authority }} <a :href="accreditationUrl" target="_blank"><i class="fa fa-share-square-o" /></a> (as checked on {{ formatDate(v.accreditation.approvedDate) }})
            </div>
            <div v-else-if="v.accreditation.status == 'NOT_ACCREDITED'" class="col-sm-10 form-control-static">
              Not Accredited (as checked on {{ formatDate(v.accreditation.approvedDate) }})
            </div>
          </div>
        </div>
        <div v-if="$service.isHSC(v.institute) && result && !result.startsWith('RESOLVE')">
          <div class="form-group">
            <label class="col-sm-2 control-label">Country</label>
            <div class="col-sm-10 form-control-static">
              {{v.institute.region}}
            </div>
          </div>
          <div v-if="v.institute.id.startsWith('QC_HS_VER_SUB')" class="form-group">
            <label class="col-sm-2 control-label">Examination Board / Authority</label>
            <div class="col-sm-10 form-control-static">
              <div v-if="v.institute.names && v.institute.names.length > 0">
                <div v-for="name in v.institute.names">{{name.name}}</div>
              </div>
              <div v-else>{{v.institute.name}}</div>
            </div>
          </div>
        </div>
        <div v-if="$service.isEmp(v.institute) && result && !result.startsWith('RESOLVE')">
          <div class="form-group">
            <label class="col-sm-2 control-label">Country</label>
            <div class="col-sm-10 form-control-static">
              {{v.institute.region}}
            </div>
          </div>
        </div>
        <div v-if="result && result.startsWith('RESOLVE')">
          <div class="form-group">
            <label class="col-sm-2 control-label">First name</label>
            <div class="col-sm-10 form-control-static">
              {{v.firstname}}
            </div>
          </div>
          <div v-if="v.middlename" class="form-group">
            <label class="col-sm-2 control-label">Middle name</label>
            <div class="col-sm-10 form-control-static">
              {{v.middlename}}
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">Last name</label>
            <div class="col-sm-10 form-control-static">
              {{v.lastname}}
            </div>
          </div>
        </div>
        <div v-if="v.dob" class="form-group">
          <label class="col-sm-2 control-label">Date of birth</label>
          <div class="col-sm-10 form-control-static">
            {{v.dob}}
          </div>
        </div>
        <div v-if="currentStudent" class="form-group">
          <label class="col-sm-2 control-label">Enrolment Status</label>
          <div class="col-sm-10 form-control-static">
            Current student
          </div>
        </div>
        <dynamic-input 
            v-for="field in filterEmptyFields(v.institute.fields)"
            v-if="!(currentStudent && field.key == 'gradYear') && field.key != 'employerContactName' && field.key != 'employerPhone' && field.key != 'employerEmail'"
            :key="field.key"
            :name="field.key"
            :label="field.label" 
            v-model="field.value" 
            :readOnly="true" />

        <div v-if="v.additionalFieldData">
          <div v-for="data in v.additionalFieldData" v-if="data.subjects">
            <div class="form-group">
              <label class="col-sm-2 control-label">Courses / Subjects</label>
              <div class="col-sm-10 form-control-static">
                <div class="row" style="padding-bottom: 10px" v-for="subject, index in data.subjects">
                    <div class="col-sm-12">{{subject.name}} - {{subject.mark}}</div>
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="notes && !$service.isId(v.institute)" class="form-group">
          <label class="col-sm-2 control-label">{{$service.isEmp(v.institute) ? 'Employer' : 'Institute'}} provided details</label>
          <div class="col-sm-10 form-control-static">
            {{notes}}
          </div>
        </div>
        <div v-if="v.approvedByName && !$service.isId(v.institute)" class="form-group">
          <label class="col-sm-2 control-label">Approved By</label>
          <div class="col-sm-10 form-control-static">
            {{v.approvedByName}} <span v-if="v.approvedByTitle">- {{v.approvedByTitle}}</span>
          </div>
        </div>
            
        <img src="/static/img/qc/logo_bullet_grey.svg" class="watermark" />
      </div>
      
      <div v-if="thirdPartyData" class="card-content row form-horizontal notes">
        <div class="form-group">
          <label class="col-sm-12 control-label">Data from records</label>
          <div class="col-sm-12 form-control-static">
            <div v-html="humanizedThirdPartyData"></div>
          </div>
        </div>
      </div>

      <div v-if="v.thirdPartyActionUrl && result == 'NOT_FOUND'" class="card-content row form-horizontal notes">
        <div class="form-group">
          <label class="col-sm-12 control-label">Action Required!</label>
          <div class="col-sm-12 form-control-static">
            <p>This verification has further steps required. Please tap the button below (mobile phone only) or scan the QR with your mobile phone.</p>
          </div>
          <div class="col-sm-12 form-control-static">
            <p class="form-control-static text-danger"><button @click.prevent="followLinkNewTab(v.thirdPartyActionUrl)" type="button" class="btn btn-wd btn-fill btn-danger"><i class="fa fa-external-link"></i>&nbsp;Complete verification</button></p>
          </div>
          <div class="col-sm-12 form-control-static">
            <p><qrcode-vue :value="v.thirdPartyActionUrl" :size="200" /></p>
          </div>
        </div>
      </div>

      <div v-if="showDocs || hasOutputDocs" class="card-content row form-horizontal notes">

        <div v-if="result && result.startsWith('RESOLVE') && docVerify" class="col-sm-12">
          <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message">Please confirm the below documents issued by your organisation are authentic.</span>
          </div>
        </div>

        <div class="form-group noprint">
          <label class="col-sm-2 control-label">Documents</label>
          <div class="col-sm-10 form-control-static">
            <div v-if="showDocs">
              <document-card
                  v-for="document, index in v.institute.documents" 
                  v-if="!document.output && (!result.startsWith('RESOLVE') || document.id)"
                  verification-status="NONE"
                  :key="index" 
                  :document="document"
                  :resultView="true"
                  style="margin-bottom: 20px" />
            </div>
            <div v-if="hasOutputDocs">
              <div v-if="hasDisplayDoc && displayDocData && displayDocData.length > 0">
                <div v-for="displayData in displayDocData" class="col-md-4">
                  <img :src="displayData" style="height: 300px" />
                </div>
                <div v-loading="!displayDocData" element-loading-spinner="qc-spinner" style="width: 25%; padding-top: 20px"></div>
              </div>
              <document-card
                  v-else
                  v-for="document, index in v.outputDocs" 
                  verification-status="NONE"
                  :key="index" 
                  :document="document"
                  :resultView="true"
                  style="margin-bottom: 20px" />
            </div>
          </div>
        </div>
        
      </div>
      
      <slot name="footer">
        <div v-if="formatResult(result)" class="card-footer">
          <p v-if="result && result.startsWith('RESOLVE')">This verification request is being processed by Qualification Check on behalf of {{v.organisation}}.</p>
          <p v-if="result == 'PENDING'">This verification is being reviewed by {{formatWhoReviews()}}. A notification will be sent by email when a result is ready.</p>
          <div v-if="result == 'VERIFIED'">
            <div class="row">
              <div v-if="$store.state.isQCAS">
                <div class="col-sm-12" style="text-align:center"><img style="height: 100px; border-radius: 4px" src="static/img/qcas/QCAS_Ecctis_logo.jpg" alt="QCAS"/></div>
              </div>
              <div v-else>
                <div :class="{'col-sm-6': $store.state.partnerLogo || v.partnerBrand}" class="col-sm-12" style="text-align:center"><div style="margin-bottom:5px">Verified by</div><img style="height: 50px; border-radius: 6px" src="static/img/qc/QC-Logo-2.png" alt="QualificationCheck"/><br/>www.qualificationcheck.com</div>
                <div v-if="$store.state.partnerLogo" class="col-sm-6" style="text-align:center"><div style="margin-bottom:5px">In partnership with</div><img style="height: 50px; max-width: 90%" :src="$store.state.partnerLogo" /></div>
                <div v-else-if="v.partnerBrand" class="col-sm-6" style="text-align:center"><div style="margin-bottom:5px">In partnership with</div><img style="height: 50px; max-width: 90%" :src="v.partnerBrand.logo" /><br/>{{v.partnerBrand.url}}</div>
              </div>
            </div>
          </div>
          <div v-if="result == 'NOT_VERIFIED'">            
            <div class="row">
              <div v-if="$store.state.isQCAS" class="col-sm-12" style="text-align:center"><img style="height: 100px; border-radius: 4px" src="static/img/qcas/QCAS_Ecctis_logo.jpg" alt="QCAS"/></div>
              <div v-else class="col-sm-12" style="text-align:center"><div style="margin-bottom:5px">Processed by</div><img style="height: 50px; border-radius: 6px" src="static/img/qc/QC-Logo-2.png" alt="QualificationCheck"/><br/>www.qualificationcheck.com</div>
            </div>
          </div>
          <p v-if="result == 'REJECTED'"></p>
          <p v-if="result == 'NOT_FOUND'"></p>
          <p v-if="result == 'CANCELLED'">This verification has been cancelled at the users request.</p>
          <p v-if="result == 'UNABLE'">This verification is delayed. We are awaiting a response from the primary source.</p>
        </div>
      </slot>
    </div>
    <slot name="actions">
      <!--<div v-if="v.id && !$store.state.isIndividual && (result == 'VERIFIED' || result == 'NOT_VERIFIED' || (result && result.startsWith('RESOLVED')))" class="card card-plain">-->
      <div v-if="v.id && !$store.state.isIndividual && (result == 'VERIFIED' || result == 'NOT_VERIFIED' || (result && result.startsWith('RESOLVED')))" class="card card-plain">
        <div class="pull-right">
          <div v-if="notes && !(result && result.startsWith('RESOLVED'))" style="margin-bottom:10px">
            Include {{$service.isEmp(v.institute) ? 'Employer' : 'Institute'}} provided details? <p-switch v-model="ignoreNotes" type="info" on-text="No" off-text="Yes"></p-switch>
          </div>
          <button @click.prevent="download" class="btn btn-fill btn-wd pull-right" v-bind:disabled="downloading" v-bind:class="{'btn-disabled': downloading}">
            <i v-if="downloading" class="fa fa-cog fa-spin" aria-hidden="true"></i>
            <span v-else class="btn-label"><i class="fa fa-download"></i>&nbsp;Download</span>
          </button>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import DocumentInput from 'src/views/Verifications/components/DocumentInput'
  import DocumentCard from 'src/views/Verifications/components/DocumentCard'
  import JsonHuman from 'json.human'
  import PSwitch from 'src/components/Switch.vue'
  import QrcodeVue from 'qrcode.vue'

  import moment from 'moment'

  export default {
    components: {
      DynamicInput,
      DocumentCard,
      DocumentInput,
      QrcodeVue,
      PSwitch
    },
    props: {
      result: String,
      notes: String,
      thirdPartyData: {},
      verification: Object,
      showDocuments: {type: Boolean, default: true},
      inApplication: {type: Boolean, default: false}
    },
    data() {
      return {
        ignoreNotes: false,
        downloading: false,
        hasDisplayDoc: false,
        displayDocData: []
      }
    },
    mounted () {
      if(this.inApplication) {
        this.loadOutputDocs()
      }
    },
    activated () {
      if(this.inApplication) {
        this.loadOutputDocs()
      }
    },
    watch: {
      verification (value) {
        if(value) {
          this.loadOutputDocs()
        }
      }
    },
    computed: {
      resolvedResult() {
        return this.inApplication && (this.result == 'REJECTED' || this.result == 'NOT_FOUND') ? 'ACTION_REQUIRED' : this.result
      },
      v() {
        return this.verification ? this.verification : {
          firstname: "Loading...",
          lastname: "",
          institute: {
            name: "Loading...",
            fields: []
          }
        }
      },
      showDocs() {
        return this.showDocuments
          && this.result != 'PENDING' 
          && this.result != 'VERIFIED' 
          && this.result != 'NOT_VERIFIED' 
          && this.result != 'CANCELLED' 
          && this.result != 'DELETED' 
          && this.result != 'UNABLE' 
          && this.v.institute.documents 
          && this.v.institute.documents.length > 0
      },
      hasOutputDocs() {
        return this.result != 'PENDING'
          && this.result != 'CANCELLED' 
          && this.result != 'DELETED' 
          && this.v.outputDocs
          && this.v.outputDocs.length > 0
      },
      docVerify() {
        if(this.verification) {
          return this.verification.docVerify
        }
        return false
      },
      currentStudent() {
        if(this.verification) {
          return this.filterEmptyFields(this.v.institute.fields).find(f => f.key == 'gradYear' && f.value == '-1') != null
        }
        return false
      },
      humanizedThirdPartyData() {
        var humaned = JsonHuman.format(this.thirdPartyData, 
          {
            // Show or hide Array-Indices in the output
            showArrayIndex: false,
            // Hyperlinks Option
            // Enable <a> tag in the output html based on object keys
            // Supports only strings and arrays
            hyperlinks : {
                enable : true,
                keys: ['url'],          // Keys which will be output as links
                target : '_blank'       // 'target' attribute of a
            },
            // Options for displaying bool
            bool : {
                // Show text? And what text for true & false?
                showText : true,
                text : {
                    true : "Yes",
                    false : "No"
                },
                // Show image? And which images (urls)?
                showImage : false
            }
          }
        )
        return humaned.outerHTML
      },
      accreditationUrl () {
        if(this.v.accreditation.url.startsWith('http')) {
          return this.v.accreditation.url
        } else {
          return 'https://' + this.v.accreditation.url
        }
      }
    },
    methods: {
      loadOutputDocs() {
        if(this.hasOutputDocs && this.$service.isId(this.v.institute)) {
            this.hasDisplayDoc = true
            var _this = this
            this.v.outputDocs.forEach(outputDoc => {
              this.$api.getDocument('verification', this.v.id, outputDoc.id)
              .then(response => {
                var imageBlob = new Blob([response.data])
                const reader = new FileReader()
                return new Promise((resolve, reject) => {
                  reader.onloadend = () => resolve(_this.displayDocData.push(reader.result) );
                  reader.readAsDataURL(imageBlob);
                })
              })
              .catch(error => {
                console.log("Failed to display document")
                console.log(error)
              })
            });
          }
      },
      formatWhoReviews() {
        if(this.$service.isEmp(this.v.institute.id)) return 'the Organisation'
        else if(this.$service.isId(this.v.institute.id)) return 'our identity partner'
        else return 'the Institute\'s records staff'
      },
      formatDate(timestamp) {
        var m = moment(timestamp)
        return m.format('DD MMM YYYY')
      },
      followLinkNewTab(link) {
        window.open(link, "_blank")
      },
      formatResult(result) {
        if(result == "NOT_FOUND" && this.v.thirdPartyActionUrl) {
          return "Action Required"
        }
        if(result && result.startsWith('RESOLVE')) {
          return "Please Resolve"
        }
        switch (result) {
          case "PENDING": return "Pending"
          case "VERIFIED": return "Verified"
          case "NOT_VERIFIED": return "Not Verified"
          case "REJECTED": return this.inApplication ? "Action Required" : "Rejected"
          case "NOT_FOUND": return this.inApplication ? "Action Required" : "Retry"
          case "CANCELLED": return "Cancelled"
          case "DELETED": return "Deleted"
          case "UNPAID": return "Unpaid"
          case "UNABLE": return "Delayed at Source"
          default: return null
        }
      },
      filterEmptyFields(fields) {
        return fields.filter(field => field.value)
      },
      download () {
        this.downloading = true
        var brand = this.$store.state.isQCAS ? "qcas" : (this.v.partnerBrand ? this.v.partnerBrand.name : null)
        this.$api.downloadResult(this.verification.id, brand, this.ignoreNotes)
          .then(response => {        
            this.doDownload(response.headers['content-disposition'], new Blob([response.data], { type: 'application/octet-stream' }))
            this.downloading = false
          })
          .catch(error => {
            this.downloading = false
            console.log("Failed to download result")
            console.log(error)
          })
      },
      doDownload (filename, blob) {
        filename = filename.substring(filename.indexOf("=") + 1);
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(function(){
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100); 
        }
      }
    }
  }

</script>

<style>
.jh-root, .jh-type-object, .jh-type-array, .jh-key, .jh-value, .jh-root tr{
 -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
 -moz-box-sizing: border-box;    /* Firefox, other Gecko */
 box-sizing: border-box;         /* Opera/IE 8+ */
 font-weight: bold;
}

.jh-key, .jh-value{
 margin: 0;
 padding: 0.2em;
 font-weight: bold;
}

.jh-value{
    border-left: 1px solid #ddd;
}
.jh-array-value {
  border-left: none;
}

.jh-type-number{
    text-align: center;
    color: #5286BC;
}

.jh-type-bool-true{
    text-align: center;
    color: #5A811C;
}

.jh-type-bool-false{
    text-align: center;
    color: #D45317;
}

.jh-type-bool-image {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    vertical-align: bottom;
}

.jh-type-string{
    font-style: italic;
    color: #6E6E6E;
}

.jh-array-key{
    font-style: italic;
    font-size: small;
    text-align: center;
}

.jh-object-key, .jh-array-key{
    color: #444;
    vertical-align: top;
    width: 25%;
}


.jh-type-object {
    background-color: #fff;
}

.jh-type-object, .jh-type-array{
    width: 100%;
    border-collapse: collapse;
}

.jh-root{
 border: 1px solid #ccc;
 margin: 0.2em;
}

th.jh-key{
 text-align: left;
}

.jh-type-object > tbody > tr{
 border: 1px solid #ddd;
 border-bottom: none;
}

.jh-type-object > tbody > tr:last-child{
 border-bottom: 1px solid #ddd;
}


.jh-empty{
 font-style: italic;
 color: #999;
 font-size: small;
}

.jh-a {
    text-decoration: none;
}


.jh-a span.jh-type-string {
    text-decoration: none;
    color : #268ddd;
    font-style: normal;
}
</style>